import React, { useState } from "react";
import './Calculator.css';

import { Heading } from "../../components";
import { FaCalendar, FaCar, FaMoneyBill } from "react-icons/fa";

const CarLoanCalculator = () => {

  // State variables to store user input and calculated monthly payment
  const [vehiclePrice, setVehiclePrice] = useState("");
  const [downPayment, setDownPayment] = useState("");
  const [loanTerm, setLoanTerm] = useState("");
  const [monthlyPayment, setMonthlyPayment] = useState(0);

  // Function to calculate the monthly loan payment
  const calculateLoan = () => {

    const price = parseFloat(vehiclePrice) || 0; // Convert input to number, default to 0 if invalid
    const down = parseFloat(downPayment) || 0; // Convert input to number, default to 0 if invalid
    const term = parseInt(loanTerm) || 1; // Convert input to integer, default to 1 if invalid

    if (price > 0 && term > 0) {
      const loanAmount = price - down; // Calculate loan amount after down payment
      const monthly = loanAmount / term; // Calculate monthly payment
      setMonthlyPayment(monthly.toFixed(2)); // Update state with formatted monthly payment
    } else {
      setMonthlyPayment(0); // Reset monthly payment if input is invalid
    }
  };

  return (
    <section className="custom-form loan-calculator">
      <div className="box-container">
        <div className="content">

          {/* Loan Calculator Form */}
          <form className="calculator-form dark-form">
  
            {/* Form Heading */}
            <Heading title={'Car Loan Calculator'} subTitle={'Calculate Your Car Loan'} sideHeading linear />

            {/* Vehicle Price Input */}
            <div className="input-box">
              <div className="input-field">
                <label htmlFor="vehicle-price"><FaCar /></label>
                <input
                  type="number"
                  id="vehicle-price"
                  className="box"
                  placeholder="Vehicle Price ($)"
                  value={vehiclePrice}
                  onChange={(e) => setVehiclePrice(e.target.value)}
                  min="1"
                  required
                />
              </div>
            </div>

            {/* Down Payment Input */}
            <div className="input-box">
              <div className="input-field">
                <label htmlFor="down-payment"><FaMoneyBill /></label>
                <input
                  type="number"
                  id="down-payment"
                  className="box"
                  placeholder="Down Payment ($)"
                  value={downPayment}
                  onChange={(e) => setDownPayment(e.target.value)}
                  min="0"
                  required
                />
              </div>
            </div>

            {/* Loan Term Input */}
            <div className="input-box">
              <div className="input-field">
                <label htmlFor="loan-term"><FaCalendar /></label>
                <input
                  type="number"
                  id="loan-term"
                  className="box"
                  placeholder="Loan Term (Months)"
                  value={loanTerm}
                  onChange={(e) => setLoanTerm(e.target.value)}
                  min="1"
                  required
                />
              </div>
            </div>

            {/* Monthly Payment Display */}
            <div className="monthly-payment">
              <h5>Monthly Payment</h5>
              <span>${monthlyPayment}</span>
            </div>

            {/* Calculate Button */}
            <div className="form-group">
              <button
                type="button"
                id="calculate-loan"
                className="btn"
                onClick={calculateLoan}
              >
                Calculate
              </button>
            </div>

          </form>
        </div>
      </div>
    </section>
  );
};

export default CarLoanCalculator;